import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class ResourceRepPush extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Push Notification: Resource Representations</h1>
				<h2>Notification</h2>
				<h4>Resource</h4>
				<table>
					<tbody>
						<tr>
							<th>Property name </th>
							<th>Value </th>
							<th>Description </th>
							<th>Note </th>
						</tr>
						<tr>
							<td> event_type </td>
							<td> String </td>
							<td> The type of the event </td>
							<td> Order, Message, Feedback </td>
						</tr>
						<tr>
							<td> resource_id </td>
							<td> Integer </td>
							<td> The ID of the resource associated with the event </td>
							<td> </td>
						</tr>
						<tr>
							<td> timestamp </td>
							<td> Timestamp </td>
							<td> The time the event occurred </td>
							<td> </td>
						</tr>
					</tbody>
				</table>
				<h4>Example</h4>
				<Highlight className="json">{`{
    "event_type":"Order",
    "resource_id":3986441,
    "timestamp":"2013-12-17T08:20:02.177Z" 
}`}</Highlight>
			</section>
		);
	}
}